const withProps = getProps => C => p => <C {...p} {...getProps(p)} />

export default withProps
